/**
 * Copyright 2022 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import * as React from 'react';
export const KeyboardModeContext = React.createContext(false);
export const useKeyboardModeGlobal = () => {
    const [keyboardMode, setKeyboardMode] = React.useState(false);
    React.useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.metaKey || e.altKey || e.ctrlKey)
                return;
            setKeyboardMode(true);
        };
        const handleClick = () => setKeyboardMode(false);
        window.addEventListener('keydown', handleKeyDown);
        window.addEventListener('mousedown', handleClick);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
            window.removeEventListener('mousedown', handleClick);
        };
    }, []);
    React.useEffect(() => {
        const attribute = 'data-starc-keyboard';
        if (keyboardMode) {
            document.body.setAttribute(attribute, '');
        }
        else {
            document.body.removeAttribute(attribute);
        }
    }, [keyboardMode]);
    return { setKeyboardMode, keyboardMode };
};
